import { render, staticRenderFns } from "./Tmembership.vue?vue&type=template&id=645b723e&scoped=true"
import script from "./Tmembership.vue?vue&type=script&lang=js"
export * from "./Tmembership.vue?vue&type=script&lang=js"
import style0 from "./Tmembership.vue?vue&type=style&index=0&id=645b723e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b723e",
  null
  
)

export default component.exports